import wellKnownSymbol$1 from './well-known-symbol.js';
import objectCreate from './object-create.js';
import './object-define-property.js';
import { __exports as objectDefineProperty } from '../../../../../../_virtual/object-define-property.js';

var wellKnownSymbol = wellKnownSymbol$1;
var create = objectCreate;
var definePropertyModule = objectDefineProperty;
var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype; // Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
} // add a key to Array.prototype[@@unscopables]


var addToUnscopables = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

export { addToUnscopables as default };
